const URL_PDF = 'https://www.openbank.es/assets/static/onboarding/pdf/';
const LEGAL_INFO_A = URL_PDF + 'legal_info_a.pdf';
const LEGAL_INFO_C = URL_PDF + 'legal_info_c.pdf';

const generatePdf = urlsPdfs => {
    return [LEGAL_INFO_A, ...urlsPdfs, LEGAL_INFO_C];
};

export default {
    generatePdf,
};
